import {t} from '@/core/utils/t'
import {documentComponent} from '@/core'

export const doc = documentComponent({
  name: 'AdminMenu',
  description: 'Menu for admin',
  categories: ['admin'],
  props: t.object({}),
  todo: [ ],
})
